// Modules
import { gql } from '@apollo/client'

export const CheckPatientFederalRevenue = gql`
    query checkPatientFederalRevenue($federalTaxId: String!) {
        checkPatientFederalRevenue(federalTaxId: $federalTaxId) {
            name
            birthDate
            situation
        }
    }
`
